import { render } from "./AgentAddUpdateModal.vue?vue&type=template&id=2676b1eb"
import script from "./AgentAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./AgentAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__